import { PlayerUtilitiesService } from './player-utilities.service';
import { Injectable } from '@angular/core';
import { BaseEntityHttpService } from '../../shared/base.httpservice';
import { HttpClient } from '@angular/common/http';
import { User } from '../../models/user';
import { ListRequestOptions, ResourceLoadResponse } from '../../shared/state';
import { mergeMap } from 'rxjs/operators';
import { Observable } from 'rxjs';

@Injectable()
export class PlayersHttpService extends BaseEntityHttpService<User> {
	readonly endpoint = this.apiUrl('users');

	constructor(http: HttpClient, private playerUtilitiesService: PlayerUtilitiesService) {
		super(http);
	}

	load(query?: ListRequestOptions): Observable<ResourceLoadResponse<User>> {
		return this.http.get<ResourceLoadResponse<User>>(`${this.endpoint}/List`, { params: query as any })
			.pipe(mergeMap(response => this.playerUtilitiesService.mapResourceAsObservable(response)));
	}

	getById(id: string) {
		return this.http.get<User>(`${this.endpoint}/${id}`).pipe(
			mergeMap(user => this.playerUtilitiesService.mapAsObservable(user))
		);
	}
}
